import * as React from "react";
import { Alert } from "antd";

const AlertMessage = ({
  title,
  message,
  type,
  closable = true
}: {
  title: string;
  message: any;
  type: "success" | "info" | "warning" | "error";
  closable?: boolean;
}) => (
  <Alert
    closable={closable}
    message={title}
    description={message}
    type={type}
    showIcon={true}
  />
);

export default AlertMessage;
